<template>
  <BoardView :pagination="pagination" :title="$t('title')" :total="total">
    <BoardTable
      :hasResults="!!total"
      :isFetching="isFetching"
      :pagination="pagination">
      <RecordArticleBlueprint
        v-for="articleBlueprint in results"
        :key="articleBlueprint.id"
        :articleBlueprint="articleBlueprint" />
    </BoardTable>
    <router-view />
  </BoardView>
</template>

<script>
import { evolve, map } from 'rambda'
import RecordArticleBlueprint from './components/RecordArticleBlueprint'
import Table from '@mixins/Table'
import { pluckId } from '@utils/collections'

const { parse, stringify } = JSON

export default {
  mixins: [Table],
  components: { RecordArticleBlueprint },
  data() {
    return {
      paginationOptions: {
        name: 'adminArticleBlueprints',
        service: 'articleBlueprint',
        filters: [
          {
            label: 'State',
            type: 'select',
            append: value => parse(value),
            options: map(evolve({ value: stringify }), [
              {
                value: { startedAt: null, failedAt: null },
                label: 'Pending',
              },
              {
                value: { isProcessing: true },
                label: 'Processing',
              },
              {
                value: {
                  doneAt: null,
                  failedAt: { $ne: null },
                },
                label: 'Failed',
              },
            ]),
          },
          {
            label: 'Sites',
            type: 'multiselect',
            optionLabel: 'name',
            trackBy: 'id',
            append: value => (value ? {
              siteId: {
                $in: pluckId('id', value),
              },
            } : {}),
            options: () => this.query('site'),
          },
        ],
        filtersValues: {
          State: '{ startedAt: null, failedAt: null }',
        },
        tabs: [
          {
            key: 'ALL',
            label: this.$t('tabs.ALL'),
            append: {},
          },
          {
            key: 'FAILED',
            label: this.$t('tabs.MINE'),
            append() {
              const userSiteIds = this.authUser
                ? pluckId('siteId', this
                  .query('siteUser', { userId: this.authUser.id }))
                : []

              return {
                siteId: { $in: userSiteIds },
              }
            },
          },
        ],
        tabsIndexes: [0],
      },
    }
  },
}
</script>

<style lang="scss">
</style>

<i18n>
{
  "en": {
    "title": "Article Blueprints",
    "tabs": {
      "ALL": "All",
      "MINE": "Mine"
    }
  }
}
</i18n>
